import { ReactNode } from "react";
import Skeleton from "react-loading-skeleton";

interface PrimaryCardProps {
  title: ReactNode;
  description: ReactNode;
  showTag?: boolean;
  tagTitle?: string;
  tagDescription?: string;
  backgroundImageUrl?: string; // Optional background image
  loading: boolean;
  tagLoading?: boolean;
}

const PrimaryCard = ({
  title,
  description,
  showTag = false,
  tagTitle = "",
  tagDescription = "",
  backgroundImageUrl,
  loading,
  tagLoading = false,
}: PrimaryCardProps) => {
  return (
    <div
      className="relative font-inter border border-card-border bg-card-background backdrop-blur-[10px] px-6 py-8 flex flex-col
    gap-[14px] items-start bg-no-repeat bg-right bg-contain w-full
  "
      style={{
        ...(backgroundImageUrl && {
          backgroundImage: `url(${backgroundImageUrl})`,
        }),
      }}
    >
      <h3 className="text-base text-white font-normal leading-[20px]">
        {title}
      </h3>
      {loading ? (
        <div className="w-full mb-4">
          <Skeleton height={32} width="50%" />
        </div>
      ) : (
        <p className="text-white font-semibold text-[32px] leading-10 mb-4">
          {description}
        </p>
      )}

      {showTag && (
        <div className="absolute top-2 right-2 bg-[#2C2C30] py-1 px-2 rounded-md text-sm font-normal flex flex-row items-center gap-1 flex-wrap">
          <p className="text-[#8E8E9A]">{tagTitle}</p>
          {tagLoading ? (
            <Skeleton height={20} width={80} />
          ) : (
            <p className="text-white">{tagDescription}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default PrimaryCard;
